import { useSelector } from 'react-redux'
import isEqual from 'lodash/isEqual'

export const useShallowEqualSelector = (selector) =>
  useSelector(selector, isEqual)
